export enum AgentSource {
  LEVEL1 = 1,
  LEVEL2 = 2,
  LEVEL3 = 3,
}
